require('./index.css')
let mask = require('../mask/index')

$(window).scroll(function () {
  if ($(this).scrollTop() > 250) {
    $("#acMoive").attr('src', 'https://v.qq.com/iframe/player.html?vid=x0712z4hxk1&tiny=1&auto=1');
    $(this).unbind()
  }
})

let questionNum = 1;

let questFirst = {
  id: 1,
  // num:'01',
  dry: '1.“弹一闪”是《爱情公寓》中谁的绝招？',
  anfirst: ' A. 曾小贤',
  ansecond: ' B. 胡一菲',
  anthird: ' C. 唐悠悠',
};

let questSecond = {
  id: 2,
  // num:'02',
  dry: '2.“我一口盐汽水喷死你”是《爱情公寓》中谁的经典台词？',
  anfirst: ' A. 吕子乔',
  ansecond: ' B. 张伟',
  anthird: ' C. 陈美嘉',
};

let questThird = {
  id: 3,
  // num:'03',
  dry: '3.电影《爱情公寓》上映时间是？',
  anfirst: ' A. 8月10日',
  ansecond: ' B. 9月17日',
  anthird: ' C. 11月11日',
};

let questFour = {
  id: 4,
  // num:'04',
  dry: '4.电影《爱情公寓》的主题曲《最好的朋友在身边》是由谁演唱的？',
  anfirst: ' A. 韦正',
  ansecond: ' B. 娄艺潇',
  anthird: ' C. 爱情公寓全体'
};

let $answer = $("input[name=answerone]");
let AQ = [];

// 上一题
$('.previous').click(function () {

  _qblog.wsd.click("LOVEAPARTMENT.PREQUEST")
  $answer.attr("checked", false);
  questionNum--;
  if (questionNum >= 1) {
    getHtml(questionNum);
  } else {
    questionNum = 1;
  }
});

// 下一题
$('.next').click(function () {
  _qblog.wsd.click("LOVEAPARTMENT.NEXTQUEST")
  zUtil.ensureLogin(function () {
    $answer.attr("checked", false);
    questionNum++;
    if (questionNum <= 4) {
      getHtml(questionNum);
    } else {
      questionNum = 4;
    }
  })
});

// 取radio值
$('input').click(function () {
  AQ[questionNum - 1] = $('input[name="answerone"]:checked').attr('value');
});

// 提交
$('.finish').click(function () {

  if ((AQ[0] === undefined) || (AQ[1] === undefined) || (AQ[2] === undefined) || (AQ[3] === undefined)) {
    mask('answerEnd')
    return;
  }//2312
  window.lottery.vote();
  let answerArr = [0, 0, 0, 0];
  var right =0;
  for (let index = 0; index < 4; index++) {
    if (AQ[index] == 1) {
      answerArr[0]++;
    } else if (AQ[index] == 2) {
      answerArr[1]++;
    } else if (AQ[index] == 3) {
      answerArr[2]++;
    } else if (AQ[index] == 4) {
      answerArr[3]++;
    }
  }
  if(AQ[0] == 2){
    right++;
  }
  if(AQ[1] == 3){
    right++;
  }
  if(AQ[2] == 1){
    right++;
  }
  if(AQ[3] == 2){
    right++;
  }
  var fenshu = (right*25);
  let answerNumId = getMaxId(answerArr);
  mask('answerNum', '测试结果：'+fenshu+'分','');

  // if (answerNumId == 0) {
  //   // 选A多
  //   mask('answerNum', '你在剧中的人物是：书澈（罗晋饰演）', '你追求个性和自我实现，正如剧中的书澈，出污泥而不染，以一己之力对抗时代和社会的某种潜规则。', 'http://stdl.qq.com/stdl/qb/kp/aa.png')
  // } else if (answerNumId == 1) {
  //   // 选B
  //   mask('answerNum', '你在剧中的人物是：萧清（唐嫣饰演）', '你心思缜密、沉着冷静，就像萧清能果断地在理智和情感间进行取舍、在爱情与正义间进行抉择。', 'http://stdl.qq.com/stdl/qb/kp/bb.png')
  // } else if (answerNumId == 2) {
  //   // 选C
  //   mask('answerNum', '你在剧中的人物是：宁鸣（于济玮饰演）', '你内心热情，但是却行事内敛。如同剧中的宁鸣，他出身于工薪阶级，却因为一段一见钟情却注定无果的暗恋而屡次挑战现实，最终一步步完成了蜕变。', 'http://stdl.qq.com/stdl/qb/kp/cc.png')
  // } else {
  //   // 选D
  //   mask('answerNum', '你在剧中的人物是：缪盈', '你是传说中别人家的孩子，事事为他人考虑。剧中的缪盈也是如此，出身富裕人家，从小身负家族使命，对自己要求严格，面对挫折和坎坷也能始终坚持前行。', 'http://stdl.qq.com/stdl/qb/kp/dd.png')
  // }
  // 提交后清空数值
  getHtml(1);
  $answer.removeAttr("checked");
  questionNum = 1;
  AQ = [];
  answerArr = [0, 0, 0, 0];
  answerNumId = 0;
});

// 取数组最大值的索引
function getMaxId(arr) {
  // 将数组第一个元素的值赋给max
  let arrmax = arr[0];
  let arrnum = 0;
  // 使用for 循环从数组第一个值开始做遍历
  for (var i = 1; i < arr.length; i++) {
    // 如果元素当前值大于max,就把这个当前值赋值给max
    if (arr[i] > arrmax) {
      arrmax = arr[i];
      arrnum = i;
    }
  }
  // 返回最大的值的索引
  return arrnum;
}

// 改变题目
function getHtml(num) {
  if (num == 1) {
    // $('.ranswer .spanNum').html('<span>'+ questFirst.num + '</span>')
    $('.answerNum').html(questFirst.id)
    $('.questions .question-dry').html(questFirst.dry)
    $('.questions .one .an-one').html(questFirst.anfirst);
    $('.questions .two .an-two').html(questFirst.ansecond);
    $('.questions .three .an-three').html(questFirst.anthird);
    $('.questions .four .an-four').html(questFirst.anfour);
    $("input[value=" + AQ[num - 1] + "]").attr('checked', 'true');
    $('.previous').css('display', 'none');
    $('.next').css('display', 'inline-block');
    $('.finish').css('display', 'none');
  } else if (num == 2) {
    // $('.ranswer .spanNum').html('<span>'+ questSecond.num + '</span>');
    $('.answerNum').html(questSecond.id)
    $('.questions .question-dry').html(questSecond.dry)
    $('.questions .one .an-one').html(questSecond.anfirst);
    $('.questions .two .an-two').html(questSecond.ansecond);
    $('.questions .three .an-three').html(questSecond.anthird);
    $('.questions .four .an-four').html(questSecond.anfour);
    $("input[value=" + AQ[num - 1] + "]").attr('checked', 'true');
    $('.previous').css('display', 'inline-block');
    $('.next').css('display', 'inline-block');
    $('.finish').css('display', 'none');
  } else if (num == 3) {
    // $('.ranswer .spanNum').html('<span>'+ questThird.num + '</span>');
    $('.answerNum').html(questThird.id)
    $('.questions .question-dry').html(questThird.dry)
    $('.questions .one .an-one').html(questThird.anfirst);
    $('.questions .two .an-two').html(questThird.ansecond);
    $('.questions .three .an-three').html(questThird.anthird);
    $('.questions .four .an-four').html(questThird.anfour);
    $("input[value=" + AQ[num - 1] + "]").attr('checked', 'true');
    $('.previous').css('display', 'inline-block');
    $('.next').css('display', 'inline-block');
    $('.finish').css('display', 'none');
  } else if (num == 4) {
    // $('.ranswer .spanNum').html('<span>'+ questFour.num + '</span>');
    $('.answerNum').html(questFour.id)
    $('.questions .question-dry').html(questFour.dry)
    $('.questions .one .an-one').html(questFour.anfirst);
    $('.questions .two .an-two').html(questFour.ansecond);
    $('.questions .three .an-three').html(questFour.anthird);
    $('.questions .four .an-four').html(questFour.anfour);
    $("input[value=" + AQ[num - 1] + "]").attr('checked', 'true');
    $('.next').css('display', 'none');
    $('.previous').css('display', 'inline-block');
    $('.finish').css('display', 'inline-block');
  }

}



// WEBPACK FOOTER //
// ./modules/video_info_answer/index.js